import React from 'react';

const Error = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-[#404f6b] via-[#2f3a52] to-black text-white grid place-items-center px-4">
            <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white/10 backdrop-blur-md p-6 text-center shadow-[0_20px_50px_-12px_rgba(250,204,21,0.25)]">
                <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-rose-500/20 ring-1 ring-rose-400/30 grid place-items-center">
                    <svg viewBox="0 0 24 24" className="h-6 w-6 text-rose-300">
                        <path fill="currentColor" d="M11 7h2v6h-2V7zm0 8h2v2h-2v-2zm1-13C6.48 2 2 6.48 2 12s4.48 10 10 10
            10-4.48 10-10S17.52 2 12 2Z"/>
                    </svg>
                </div>

                <h1 className="text-2xl font-extrabold tracking-tight mb-2 bg-gradient-to-r from-yellow-300 via-amber-200 to-yellow-400 bg-clip-text text-transparent">
                    Sorry, something went wrong
                </h1>

                <p className="text-indigo-100/90 mb-2">
                    We were unable to process your request. We’ll email you soon.
                </p>
                <p className="text-indigo-200">
                    If you don’t hear from us, contact us at{" "}
                    <a
                        href="mailto:hello@galacticplanner.com"
                        className="text-yellow-300 hover:text-yellow-200 underline underline-offset-4"
                    >
                        hello@galacticplanner.com
                    </a>.
                </p>
            </div>
        </div>
    );

};

export default Error;
